export const SystemRouter = [
  // {
  //   path: '/Login/:CommunityID',
  //   name: 'LoginC',
  //   component: () =>
  //     import('@/Views/Main/Login.vue'),
  //   props: (route) => ({
  //     query: route.query.CommunityID
  //   }),
  // },
  {
    path: "/",
    name: "Login",
    component: () => import("@/Views/Main/Login.vue"),
    props: route => ({
      query: route.query.CommunityID
    })
  },

  {
    path: "/SSOLogin",
    name: "SSOLogin",
    component: () => import("@/Views/Main/SSOLogin.vue"),
    props: route => ({
      query: route.query.SysLogID,
      query: route.query.OpenURL,
      query: route.query.CommunityID
    })
  },
  {
    path: "/SelectSystem",
    name: "SelectSystem",
    component: () => import("@/Views/Main/SelectSystem.vue")
  },
  {
    path: "/Index",
    name: "Index",
    component: () => import("@/Views/Main/Index.vue")
  },
  {
    path: "/IndexHTemplate",
    name: "IndexHTemplate",
    component: () => import("@/Views/Template/IndexHTemplate.vue")
  },
  {
    path: "/IndexTreeTemplate",
    name: "IndexTreeTemplate",
    component: () => import("@/Views/Template/IndexTreeTemplate.vue")
  },
  {
    path: "/IndexVTemplate",
    name: "IndexVTemplate",
    component: () => import("@/Views/Template/IndexVTemplate.vue")
  },
  {
    path: "/IndexNoTemplate",
    name: "IndexNoTemplate",
    component: () => import("@/Views/Template/IndexNoTemplate.vue")
  },
  {
    path: "/IndexTitleTemplate",
    name: "IndexTitleTemplate",
    component: () => import("@/Views/Template/IndexTitleTemplate.vue")
  },
  {
    path: "/IndexTMTemplate",
    name: "IndexTMTemplate",
    component: () => import("@/Views/Template/IndexTMTemplate.vue")
  },
  {
    path: "/IndexVTRemplate",
    name: "IndexVTRemplate",
    component: () => import("@/Views/Template/IndexVTRemplate.vue")
  },
  {
    path: "/ChangePWD",
    name: "ChangePWD",
    component: () => import("@/Views/Main/ChangePWD.vue")
  },
  {
    path: "/ResetPWD",
    name: "ResetPWD",
    component: () => import("@/Views/Main/ResetPWD.vue"),
    props: route => ({
      query: route.query.CommunityID
    })
  },
  {
    path: "/Test",
    name: "Test",
    component: () => import("@/Views/Main/Test.vue")
  },
  {
    //保存用户信息
    path: "/GetUserInfo",
    name: "GetUserInfo",
    component: () => import("@/Views/Main/GetUserInfo.vue")
  },
  {
    path: "/403",
    name: "403",
    component: () => import("@/Views/Main/403.vue")
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/Views/Main/500.vue")
  },

  {
    path: "/*",
    name: "404",
    component: () => import("@/Views/Main/404.vue")
  }
];

export const routers = [...SystemRouter];



// WEBPACK FOOTER //
// ./src/router/router.js